import {FC, useState} from 'react'
import styles from './MissingOnHrMasterIcon.scss'
import {HoverDescription, DescriptionContainer} from 'jbc-front/components/presenters/ui/HoverDescription'
import {Alert} from 'jbc-front/components/icons'
import {OrganizationType, organizationTypeName} from '../query'
import classnames from 'classnames'

interface MissingOnHrMasterIconProps {
  organizationType: OrganizationType
  className: string
}

export const MissingOnHrMasterIcon: FC<MissingOnHrMasterIconProps> = ({organizationType, className}) => {
  const orgName = organizationTypeName(organizationType)
  const alertMessage = `共通マスタから連携されていない${orgName}です。`
  const [isHover, setIsHover] = useState<boolean>(false)

  const handleEnter = () => {
    setIsHover(true)
  }

  const handleLeave = () => {
    setIsHover(false)
  }

  return (
    <DescriptionContainer
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      className={classnames(styles.icon, className)}
    >
      <Alert size={17} />
      <HoverDescription position="top" isHover={isHover} margin={30}>
        {alertMessage}
      </HoverDescription>
    </DescriptionContainer>
  )
}
